import PropTypes from "prop-types";
import { withSection } from "../../../../hoc";

import { alignItems, strCode } from "../../../../consts";
import { t } from "../../../../services";

import {
  FlexContainers,
  Heading5,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../../components";
import { DeactivateCampaignModalWrapper } from "./styled";

const _DeactivateCampaignModal = ({ campaignName, active, setActive, onDeactivate }) => {
  return (
    <DeactivateCampaignModalWrapper>
      <Modal id="deactivate-campaign-modal" active={active} closable={false} preventOverflow>
        <WrapperContainer
          Container={FlexContainers.FlexColumnStart}
          alignItems={alignItems.start}
          width={380}
          gap={16}>
          <Heading5>{t(strCode.DEACTIVATE_CAMPAIGN_TITLE)}</Heading5>

          <Paragraph2
            dangerouslySetInnerHTML={{
              __html: t(strCode.DEACTIVATE_CAMPAIGN_TEXT, { campaignName })
            }}
          />

          <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={16} mt={8} width={"100%"}>
            <SmallButton onClick={() => setActive(false)} secondary={true}>
              {t(strCode.NO_BTN)}
            </SmallButton>

            <SmallButton onClick={onDeactivate} backgroundRed>
              {t(strCode.YES_DEACTIVATE_BTN)}
            </SmallButton>
          </WrapperContainer>
        </WrapperContainer>
      </Modal>
    </DeactivateCampaignModalWrapper>
  );
};

_DeactivateCampaignModal.propTypes = {
  campaignName: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired
};

export const DeactivateCampaignModal = withSection(_DeactivateCampaignModal);
